import { useSessionStorageState } from '@faro/app-context';
import React, { PropsWithChildren } from 'react';
import { createSafeContext } from '../../../../../util/createSafeContext';

export interface ScheduleOfActivitiesContextValue {
    selectedScheduleOfActivitiesId: string | undefined;
    setSelectedScheduleOfActivitiesId: (value: string | undefined) => void;
}

// Provides selectedScheduleOfActivitiesId and setSelectedScheduleOfActivitiesId to ScheduleOfActivities Section and Insights.
// By default the state is undefined to prevent unnecessary API calls. Only when the user visits either components that consumes
// the context, if the state is not already set (via Query Params or Storage), then the state is set to the default scheduleId.
export function ScheduleOfActivitiesProvider({ children }: PropsWithChildren<unknown>): React.JSX.Element {
    const [selectedScheduleOfActivitiesId, setSelectedScheduleOfActivitiesId] = useSessionStorageState<
        string | undefined
    >('soaId', undefined);

    const contextValue = {
        selectedScheduleOfActivitiesId,
        setSelectedScheduleOfActivitiesId,
    };

    return <ScheduleOfActivitiesInnerProvider value={contextValue}>{children}</ScheduleOfActivitiesInnerProvider>;
}

const [ScheduleOfActivitiesInnerProvider, useScheduleOfActivitiesContext] =
    createSafeContext<ScheduleOfActivitiesContextValue>('ScheduleOfActivities');

export { useScheduleOfActivitiesContext };
